import React from 'react';
import AiReplyAvatar from './AiReplyAvatar';

/**
 * Shown in place of a missing assistant reply.
 * Retry sends the same question again.
 */
export default function AssistantErrorBubble({ message, onRetry, colors }) {
  const palette = colors || {};
  const text = palette.text || '#1f2937';
  const surface = palette.surface || '#ffffff';
  const border = palette.border || '#e5e7eb';
  const primary = palette.primary || '#59c4c4';
  return (
    <div
      role="alert"
      data-assistant-error="true"
      style={{
        marginBottom: '1rem',
        display: 'flex',
        justifyContent: 'flex-start',
        gap: '0.5rem',
        alignItems: 'flex-end',
      }}
    >
      <AiReplyAvatar />
      <div style={{
        maxWidth: '85%',
        padding: '1rem 1.25rem',
        borderRadius: '1.25rem 1.25rem 1.25rem 0.25rem',
        background: surface,
        color: text,
        border: `1px solid ${border}`,
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        fontSize: '0.95rem',
        lineHeight: 1.5,
      }}
      >
        <div style={{ whiteSpace: 'pre-wrap' }}>{message}</div>
        {onRetry ? (
          <button
            type="button"
            onClick={onRetry}
            style={{
              marginTop: '0.75rem',
              minHeight: '44px',
              padding: '0.5rem 1rem',
              borderRadius: '0.75rem',
              border: 'none',
              background: primary,
              color: '#ffffff',
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Retry
          </button>
        ) : null}
      </div>
    </div>
  );
}
